/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectFormatRecordFlagUpdateRequest { 
    /**
     * Indicates if business object data registered with this format is a record or non-record
     */
    recordFlag?: boolean;
    /**
     * Indicates if record flag should be reset back to its initial state (not specified)
     */
    resetRecordFlag?: boolean;
    /**
     * Indicates record code for business object data registered with this format
     */
    recordCode?: string;
}
